import { apiCallPost } from '../api';
import { apiPaths } from '../config/apiPaths';

export const uploadTemplateMediaApi = async (payload = {}, authHeaders = {}) => {
  try {
    const requestPayload = {
      operation: 'UPLOAD_TEMPLATE_MEDIA',
      payload
    };

    const res = await apiCallPost(apiPaths.whatsappTemplate, requestPayload, authHeaders);

    if (res) {
      return { data: res, status: true };
    }

    return { data: {}, status: false, errMsg: 'Failed to upload template media' };
  } catch (err) {
    return { status: false, errMsg: err.message || 'Failed to upload template media' };
  }
};
